/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 * @flow
 */

import { css } from '@emotion/core'

export default css`
  body {
    text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
  }
  .prism-code {
    background: #282c34;
    color: #ffffff;
    border-radius: 10px;
    overflow: auto;
    tab-size: 1.5em;
    -webkit-overflow-scrolling: touch;
    font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace;
  }

  html{
    --code-title-text: #fff;
    --code-title-bg: radial-gradient(
        6px at 14px 50%,
        #ff554f 0px,
        #ff635a 4px,
        #fd5249 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      radial-gradient(
        6px at 34px 50%,
        #ffbe2d 0px,
        #ffc42f 4px,
        #fcb91b 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      radial-gradient(
        6px at 54px 50%,
        #2acd44 0px,
        #2acd44 4px,
        #2acd44 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      linear-gradient(to bottom, #272629 0%, #242224 1px, #242224 100%);
  }
  @media (prefers-color-scheme: dark) {
    html{
      --code-title-text: #333;
      --code-title-bg: radial-gradient(
        6px at 14px 50%,
        #ff554f 0px,
        #ff635a 4px,
        #fd5249 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      radial-gradient(
        6px at 34px 50%,
        #ffbe2d 0px,
        #ffc42f 4px,
        #fcb91b 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      radial-gradient(
        6px at 54px 50%,
        #2acd44 0px,
        #2acd44 4px,
        #2acd44 5px,
        rgba(255, 255, 255, 0) 6px
      ),
      linear-gradient(to bottom, #ececec 0%, #ececec 1px, #ececec 100%);
    }
  }
  code.prism-code,
  pre.prism-code {
    height: auto !important;
    margin: 0 0 1rem 0;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    word-break: break-word;
    padding: 20px 25px 20px;
  }

  .prism-code + .prism-code {
    margin-top: 20px;
  }

  .prism-code .highlight-line {
    background-color: #353b45;
    display: block;
    margin: -0.125rem -10px -0.125rem calc(-1rem - 15px);
    padding: 0.125rem calc(1rem + 15px);
    border: none;
  }

  .token.attr-name {
    color: #c5a5c5;
  }

  .token.comment,
  .token.block-comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: #b2b2b2;
  }

  .token.property,
  .token.number,
  .token.function-name,
  .token.constant,
  .token.symbol,
  .token.deleted {
    color: #5a9bcf;
  }

  .token.boolean {
    color: #ff8b50;
  }

  /*.token.tag {
  color: #fc929e;
}*/

  .token.string {
    color: #8dc891;
  }

  .token.punctuation {
    color: #88c6be;
  }

  .token.selector,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #d8dee9;
  }

  .token.function {
    color: #79b6f2;
  }

  .token.operator,
  .token.entity,
  .token.url,
  .token.variable {
    color: #d7deea;
  }

  .token.attr-value {
    color: #8dc891;
  }

  .token.keyword {
    color: #c5a5c5;
  }

  .token.atrule,
  .token.class-name {
    color: #fac863;
  }

  .token.important {
    font-weight: 400;
  }

  .token.bold {
    font-weight: 700;
  }

  .token.italic {
    font-style: italic;
  }

  .token.entity {
    cursor: help;
  }

  span.token.function-variable {
    color: #ffcc66;
  }

  .namespace {
    opacity: 0.7;
  }

  .cd-w-pv {
    display: flex;
    margin: 1em 0;
    border-radius: 10px;
    overflow: hidden;
  }

  .cd-w-pv_preview {
    background: #efeeee;
    flex: 1;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    display: flex;
    flex-direction: column;
    min-height: 200px;
    position: relative;
  }
  .cd-w-pv_preview-content {
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cd-w-pv-title {
    text-align: center;
    color: var(--code-title-text);
    height: 30px;
    line-height: 30px;
    flex-shrink: 0;
    background: var(--code-title-bg);

    overflow: hidden;
  }
  .cd-w-pv-title.no-dots {
    background: linear-gradient(to bottom, #272629 0%, #242224 1px, #242224 100%);
  }
  .cd-w-pv.cd-w-pv-column .cd-w-pv_preview .cd-w-pv-title {
    display: none;
  }
  .cd-w-pv-detach .cd-w-pv_preview:not(:first-of-type) {
    margin-left: 10px;
    border-radius: 10px;
    overflow: hidden;
  }
  .cd-w-pv-detach .cd-w-pv_codes {
    border-radius: 10px;
    overflow: hidden;
  }
  .cd-w-pv_code pre.prism-code {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0;
    border-radius: 0;
  }

  .cd-w-pv_code {
    background: #061526;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: auto;
  }

  .cd-w-pv_code > div:nth-last-of-type(2) {
    height: 100%;
    flex: auto;
    display: flex;
    align-items: center;
  }
  .cd-w-pv_preview-expand,
  .cd-w-pv_code-copy {
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: #fff;
    background: #333940;
    font-size: 12px;
    padding: 1px 4px;
    cursor: pointer;
    opacity: 0.7;
    border-radius: 3px;
    display: none;
    z-index: 99;
  }
  .cd-w-pv_preview-expand:hover,
  .cd-w-pv_code-copy:hover {
    opacity: 1;
  }
  .cd-w-pv_preview:hover .cd-w-pv_preview-expand,
  .cd-w-pv_code:hover .cd-w-pv_code-copy {
    display: block;
  }
  .cd-w-pv.cd-w-pv-column {
    flex-direction: column;
  }
  .cd-w-pv.cd-w-pv-hide-code {
    flex-direction: column-reverse;
  }
  .cd-w-pv.cd-w-pv-hide-code .cd-w-pv_preview .cd-w-pv-title {
    display: block;
  }
  .cd-w-pv.cd-w-pv-hide-code .cd-w-pv_codes .cd-w-pv-title {
    display: none;
  }
  .cd-w-pv_codes {
    flex: 1;
    display: flex;
    flex-direction: column;
    display: none;
  }
  .cd-w-pv-expanded .cd-w-pv_codes {
    display: block;
  }
  .cd-w-pv_codes .cd-w-pv_code:nth-of-type(2) pre.prism-code {
    background: #131d29 !important;
  }
  .cd-w-pv_codes .cd-w-pv_code:nth-of-type(3) pre.prism-code {
    background: #182738 !important;
  }
  .cd-w-pv_codes .cd-w-pv_code:nth-of-type(4) pre.prism-code {
    background: #131d29 !important;
  }
  .cd-w-pv_codes .cd-w-pv-title + .cd-w-pv_code pre.prism-code {
    background: rgba(0, 0, 0, 0) !important;
  }
  .cd-w-pv-white .cd-w-pv-title {
    height: 30px;
    color: #454;
    color: var(--code-title-text);
    flex-shrink: 0;
    background: var(--code-title-bg);
  }
  .cd-w-pv-white {
    border: 1px solid var(--color-line);
  }
  .leet-code-playground-run {
    width: 50px;
    height: 50px;
    position: absolute;
    top: -25px;
    right: 25px;
    background: #3f51b5;
    border-radius: 50%;
    color: #fff;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .leet-code-playground-run:hover {
    background: #4b5590;
  }
  .leet-code-playground-run:active {
    background: #2e3978;
  }
  .leet-code-playground-result table {
    background: transparent;
  }
  .leet-code-playground-result td {
    padding: 1px;
    border-color: #d6e3e6;
    font-size: 14px;
  }
  .sort-demo-table td {
    border-color: transparent;
    padding: 0;
    border-width: 0 0 1px 0;
    text-align: center;
    width: 10px;
  }
  .leet-code-playground-tree {
    td {
      text-align: center;
      border: none;
      vertical-align: top;
      padding: 0px;
    }
    td span {
      background: #009688;
      padding: 0 5px;
      margin: 0 1px;
    }
  }
`
